"use client";

import React, { useRef } from "react";
import Image from "next/image";
import { Swiper, SwiperSlide } from "swiper/react";
import SwiperBase from "swiper";
import { Navigation } from "swiper/modules";
import { FiChevronLeft, FiChevronRight } from "react-icons/fi";
import get from "lodash/get";
import { PrismicRichText } from "@prismicio/react";

// interfaces
import { PrismicInterface } from "@/types/prismicio-types";

// assets
import styles from "@/assets/styles/pages/blog/single-block-slider.module.scss"
import "swiper/css";
import "swiper/css/navigation";

interface SingleBlockSliderProps {
  blog: PrismicInterface["PostsDocumentDataBodySliderImagesSlice"];
}


function SingleBlockSlider({ blog }: SingleBlockSliderProps) {
  const swiperRef = useRef<SwiperBase | null>(null);

  return (
    <div className={styles["slider-container"]}>
      <div className={styles["slider-container__inner"]}>
        <Swiper
          loop
          modules={[Navigation]}
          onBeforeInit={(swiper) => {
            swiperRef.current = swiper;
          }}
          className={styles["slider-container__swiper"]}
        >
          {
            blog.items.map((el, index) => (
              <SwiperSlide key={`blog-item-${index}`}>
                <Image
                  src={el.sliderimg.url as string}
                  className={styles["slider-container--img"]}
                  alt=""
                  fill
                  sizes="100vh"
                />
              </SwiperSlide>
            ))
          }
        </Swiper>
        <span
          className={`${styles["slider-container__swiper-arrow"]} ${styles["slider-container__swiper-arrow_left"]}`}
          onClick={() => swiperRef.current && swiperRef.current.slidePrev()}
        >
          <FiChevronLeft/>
        </span>
        <span
          className={`${styles["slider-container__swiper-arrow"]} ${styles["slider-container__swiper-arrow_right"]}`}
          onClick={() => swiperRef.current && swiperRef.current.slideNext()}
        >
          <FiChevronRight/>
        </span>
      </div>
      <div className={styles["slider-container--text"]}>
        <PrismicRichText field={get(blog, "primary.slidercotations", [])} />
      </div>
    </div>
  );
}

export default SingleBlockSlider;
